<template>
  <div class='moreVersionItem'>
    <div class="title">{{ title }}</div>
    <div class="value-box">
      <div class="box version1-box"> {{ getValue(model?.num1) }}</div>
      <div class="box version2-box">{{ getValue(model?.num2) }}</div>
      <div class="box com-box" :style="{ backgroundColor: getColor() }">{{ compareValue() }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'moreVersionItem',
  props: {
    title: {
      type: String,
      default: ''
    },
    model: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
    }
  },
  methods: {
    getItemValue(value) {
      let isTimeValue = false;
      if (
        this.title.includes("Time") ||
        this.title.includes("time")
      ) {
        isTimeValue = true;
      }
      let h, min, sec, sum;
      if (isTimeValue) {
        if (value.includes("h")) {
          h = value.split("h")[0];
          const timeStr = value.split("h")[1];
          if (timeStr.includes("m")) {
            min = timeStr.split("m")[0];
            sec = timeStr.split("m")[1];
          }
          sum = h * 3600 + min * 60 + parseFloat(sec);
        } else if (value.includes("m")) {
          min = value.split("m")[0];
          sec = value.split("m")[1];
          sum = min * 60 + parseFloat(sec);
        } else if (value.includes("s")) {
          sum = parseFloat(value);
        } else {
          sum = parseFloat(value);
        }
      } else {
        sum = parseFloat(value);
      }
      return sum;
    },
    getValue(num) {
      if (num) {
        return num;
      }
      return "-";
    },
    getColor() {
      if (!this.model?.num1 || !this.model?.num2 || (this.model?.num1 == this.model?.num2)) {
        return "#707070";
      } else {
        if (parseFloat(this.model?.num1) > parseFloat(this.model?.num2)) {
          return "#F18B8B";
        }
        return "#AEDFA9";
      }
    },
        compareValue() {
      if (this.model?.num1 && this.model?.num2) {
        let valueStr = "";
        if (this.model?.num1 == this.model?.num2) {
          return "/";
        } else {
          const v1 = this.getItemValue(this.model?.num1);
          const v2 = this.getItemValue(this.model?.num2);
          const comValue = 1 - v1 / v2;
          if (v2 == 0) {
            return "/";
          } else {
            if (comValue == 0) {
              valueStr = comValue * 100 + "%";
              return "/";
            } else {
              valueStr = (comValue * 100).toFixed(1) + "%";
            }
          }
          console.log("valueStr = ", valueStr);
          return valueStr;
        }
      }
      return "/";
    },
  },
  computed: {
  },
  created() {
    
  }
}
</script>
<style lang='less' scoped>
 
 .moreVersionItem {
   margin-top: 20px;
   width: 100%;

   .title {
     font-size: 16px;
     font-weight: bold;
     color: #565656;
   }

   .value-box {
     margin-top: 10px;
     width: 100%;
     height: 46px;
     display: flex;
     flex-direction: row;

     .box {
       height: 100%;
       border: 0.5px solid #707070;
       border-radius: 3px;
       display: flex;
       align-items: center;
       font-size: 16px;
       color: #565656;
     }

     .version1-box {
       width: 160px;
       background-color: #FFFFFF;
       padding-left: 10px;
     }

     .version2-box {
       width: 160px;
       background-color: #F6F6F6;
       padding-left: 10px;
       margin-left: 15px;
     }

     .com-box {
       width: 80px;
       background-color: #F18B8B;
       border-width: 0px;
       text-align: center;
       justify-content: center;
       color: #FFFFFF;
       margin-left: 30px;
     }
    
   }

 }
</style>